import { error as logError } from '../utils/logger'
import { apiUrl } from '../config/config'
import { sendRequest } from '../utils/FetchServices'
import { ResponseSendMessageDoti } from './interfaces/doti/doti.sendmessage.interface'

interface PropsGetDoti {
    authToken: string
    userLat: string
    userLng: string
    retries?: number
    timeout?: number
}

export const request_get_doti = async ({
    authToken,
    userLat,
    userLng,
    retries = 2,
    timeout = 60,
}: PropsGetDoti) => {
    const URL = apiUrl + '/oneapp/get_doti'
    try {
        const headers = {
            Authorization: authToken,
            lat: userLat.toString(),
            lng: userLng.toString(),
        }
        console.log('Mandé el msj')
        const data = await sendRequest(URL, 'GET', headers, null, retries, timeout)

        return data.response
    } catch (error) {
        logError('TriviaService', 'request_get_doti failed', error)
        return null
    }
}
interface PropsSendMessageDoti {
    authToken: string
    question: string
    session_id?: string
    userLat: number
    userLng: number
    retries?: number
    timeout?: number
}

export const request_send_message_doti = async ({
    authToken,
    question,
    session_id = null,
    userLat = 0,
    userLng = 0,
    retries = 2,
    timeout = 60,
}: PropsSendMessageDoti) => {
    const URL = apiUrl + '/oneapp/send_message_doti'
    try {
        const headers = {
            Authorization: authToken,
        }
        const body = {
            question: question,
            session_id: session_id,
            lat: userLat.toString(),
            lng: userLng.toString(),
        }

        // console.log('request_send_message_doti - body:', body) // Log del body antes de enviar la solicitud

        const data = await sendRequest(URL, 'POST', headers, body, retries, timeout)
        return data.response as ResponseSendMessageDoti
    } catch (error) {
        logError('Doti Service', 'send_message_doti failed', error)
        return null
    }
}
